module.exports = __webpack_public_path__ + "static/media/nf.4040b7b9.jpeg";